import { applyMiddleware, createStore, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "../reducers/RootReducer";
import { getFromLocal, existInLocal } from "../../utils/Cache";
import { authInitialState } from "../reducers/InitialState";
import ability from "../../config/ability";
import { LOCAL_STORAGE_KEYS } from "../../config/constants";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

export const checkAndRestoreFromLocal = () => {
  // Name should be same as those of the reducers
  let userAuth = authInitialState;
  if (existInLocal(LOCAL_STORAGE_KEYS.auth)) {
    userAuth = Object.assign(
      {},
      userAuth,
      getFromLocal(LOCAL_STORAGE_KEYS.auth)
    );
  }
  // if (existInLocal(LOCAL_STORAGE_KEYS.mfaFactors)) {
  //   userAuth = {
  //     ...userAuth,
  //     mfa: getFromLocal(LOCAL_STORAGE_KEYS.mfaFactors),
  //   };
  // }
  ability.update((userAuth.scopes as any) || []);
  return {
    userAuth,
  };
};

const persistedState = checkAndRestoreFromLocal();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middlewares = [thunk];

const store = createStore(
  rootReducer,
  persistedState,
  composeEnhancers(applyMiddleware(...middlewares))
);

export default store;
